import { api } from '@/api';
import type { CustomerProfileParametersDTO } from '@/types/dto/agent';
import { useEffect, useState } from 'react';

type PasswordComplexity = Pick<
  CustomerProfileParametersDTO,
  'passwordComplexityRegexLocalization' | 'passwordComplexityRegex'
>;

const usePasswordComplexity = (enabled = true) => {
  const [passwordComplexity, setPasswordComplexity] = useState<{
    regex: PasswordComplexity['passwordComplexityRegex'];
    regexLocalization: PasswordComplexity['passwordComplexityRegexLocalization'];
  } | null>(null);
  const [loading, setLoading] = useState(enabled);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    async function getPasswordRequirements() {
      try {
        const { passwordComplexityRegexLocalization, passwordComplexityRegex } =
          (
            await api.agentApi.CustomerProfilesConfiguration_GetCustomerProfilesParameters()
          ).data;

        setPasswordComplexity({
          regexLocalization: passwordComplexityRegexLocalization,
          regex: passwordComplexityRegex,
        });
      } catch {
        // Config fetch failed — fall back to the schema's default rules instead of hanging on a spinner.
        setPasswordComplexity(null);
      } finally {
        setLoading(false);
      }
    }

    getPasswordRequirements();
  }, [enabled]);

  return { passwordComplexity, loading };
};

export default usePasswordComplexity;
